import { combineReducers } from 'redux';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';
import { DEALER_SOURCE } from '../../constants';
import type { DeleteTemplateAction, DeleteTemplateSuccessAction, FetchTemplatesFOByDealerSuccessAction } from '../../types/actions';

type ActionWithMeta = { meta?: { source?: string } };

const isDealerSource = (action: ActionWithMeta) => action.meta?.source === DEALER_SOURCE;

const setIdsFromFoByDealer = (_: string[], action: FetchTemplatesFOByDealerSuccessAction) => action.payload!.content.map(({ id }) => id);

const removeDeletedId = (state: string[], action: DeleteTemplateSuccessAction & ActionWithMeta) => {
  if (!isDealerSource(action)) {
    return state;
  }
  return state.filter(id => id !== action.payload);
};

const setDeletingId = (state: string | null, action: DeleteTemplateAction & ActionWithMeta) => {
  if (!isDealerSource(action)) {
    return state;
  }
  return action.payload!.templateId;
};

const resetDeleting = (state: string | null, action: ActionWithMeta) => {
  if (!isDealerSource(action)) {
    return state;
  }
  return null;
};

export default combineReducers({
  ids: createReducer([], {
    [types.FETCH_TEMPLATES_FO_BY_DEALER_SUCCESS]: setIdsFromFoByDealer,
    [types.DELETE_TEMPLATE_SUCCESS]: removeDeletedId,
    [SELECT_DEALER]: () => [],
  }),
  deleting: createReducer(null, {
    [types.DELETE_TEMPLATE]: setDeletingId,
    [types.DELETE_TEMPLATE_SUCCESS]: resetDeleting,
    [types.DELETE_TEMPLATE_FAILURE]: resetDeleting,
  }),
});
